import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';
import type { OpenIssuesByWorkflow, PropertyListItem, WorkflowRunsByWorkflow } from './types';
import { buildOpenIssuesUrl, buildRecentWorkflowRunsUrl } from './recentRuns';

type FetchLike = (input: string | URL | Request, init?: RequestInit) => Promise<Response>;

export async function fetchFlowListProperties(
  fetchImpl: FetchLike = fetch
): Promise<{ items: PropertyListItem[] }> {
  const response = await fetchImpl(`${API_URL}/org/properties`, { credentials: 'include' });
  if (!response.ok) {
    throw await toApiError(response, 'Failed to load properties');
  }
  return response.json() as Promise<{ items: PropertyListItem[] }>;
}

export async function fetchFlowListRecentRuns(
  workflowIds: string[],
  fetchImpl: FetchLike = fetch
): Promise<WorkflowRunsByWorkflow> {
  const response = await fetchImpl(buildRecentWorkflowRunsUrl({ apiUrl: API_URL, workflowIds }), {
    credentials: 'include',
  });
  if (!response.ok) {
    throw await toApiError(response, 'Failed to load workflow runs');
  }
  const data = (await response.json()) as { runsByWorkflow?: WorkflowRunsByWorkflow };
  return data.runsByWorkflow ?? {};
}

export async function fetchFlowListOpenIssues(
  workflowIds: string[],
  fetchImpl: FetchLike = fetch
): Promise<OpenIssuesByWorkflow> {
  if (workflowIds.length === 0) return {};
  const response = await fetchImpl(buildOpenIssuesUrl({ apiUrl: API_URL, workflowIds }), {
    credentials: 'include',
  });
  if (!response.ok) {
    throw await toApiError(response, 'Failed to load open issues');
  }
  const data = (await response.json()) as { issuesByWorkflow?: OpenIssuesByWorkflow };
  return data.issuesByWorkflow ?? {};
}
